import { faCog } from '@fortawesome/pro-regular-svg-icons/faCog';
import React from 'react';
import styled from 'styled-components';
import { PROFILE_URL } from '../../constants/urls';
import { useIsScreenSize } from '../../hooks/useIsScreenSize';
import THEME from '../../styles/colors';
import IconButton from '../../ui/Button/IconButton';
import Anchor from '../Anchor/Anchor';
import Flyout from '../Flyout/Flyout';
import HamburgerMenu from '../HamburgerMenu/HamburgerMenu';
import UserMenu from '../UserMenu/UserMenu';
import useSiteNavContext from './SiteNavContext';
import {
  getHamburgerLinksData,
  SITE_NAV_BREAK_POINT,
  SITE_NAV_MODE
} from './SiteNavUtils';

const StyledMobileMenu = styled.div`
  position: fixed;
  top: 0;
  left: 0;

  height: 100vh;
  width: 100%;

  pointer-events: auto;
  overflow-x: hidden;
  overflow-y: auto;

  padding: 20px;

  background: ${THEME.surface.primary};
`;

const StyledFlyoutHeader = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;

  position: relative;

  & > button,
  & > a {
    position: absolute;
    top: 0;
    &:first-child:not(:last-child) {
      left: 0;
    }
    &:last-child {
      right: 0;
    }
  }
`;

interface IMenuHeaderProps {
  onClose: Function;
  isSettingsLinkVisible?: boolean;
}

const MenuHeader: React.FC<IMenuHeaderProps> = ({
  onClose,
  isSettingsLinkVisible
}) => (
  <StyledFlyoutHeader>
    {isSettingsLinkVisible && (
      <Anchor href={PROFILE_URL}>
        {/* @ts-ignore */}
        <IconButton icon={faCog} size={24} as="div" />
      </Anchor>
    )}
    <IconButton size={24} onClick={onClose} />
  </StyledFlyoutHeader>
);

const MenuManager = () => {
  const { siteNavData, setNavMode, navMode } = useSiteNavContext();
  const hamburgerNavData = getHamburgerLinksData(siteNavData);
  const isDesktop = useIsScreenSize(SITE_NAV_BREAK_POINT);

  const onClose = () => setNavMode(SITE_NAV_MODE.None);

  let content;
  const headerProps = {
    onClose,
    isSettingsLinkVisible: false
  };

  if (navMode === SITE_NAV_MODE.HamburgerMenu) {
    content = <HamburgerMenu hamburgerNavData={hamburgerNavData} />;
  } else if (navMode === SITE_NAV_MODE.HamburgerMenuSearch) {
    content = (
      <HamburgerMenu hamburgerNavData={hamburgerNavData} isSearchFocused />
    );
  } else if (navMode === SITE_NAV_MODE.UserMenu) {
    content = <UserMenu />;
    headerProps.isSettingsLinkVisible = true;
  }

  const header = <MenuHeader {...headerProps} />;

  return (
    <div>
      {isDesktop ? (
        <Flyout onClose={onClose}>
          {header}
          {content}
        </Flyout>
      ) : (
        <StyledMobileMenu>
          {header}
          {content}
        </StyledMobileMenu>
      )}
    </div>
  );
};

export default MenuManager;
